<template>

    <Page>

        <ImageAndText 
            src="/ExecutiveSummary/executive-summary-1.jpg"
            animation="slide-up"
            border
            image-class="rounded-xl"
            floor-shadow
            :flip="true">

            <h2 class="mb-4 text-xl">Profits are tight, and shifting</h2>
            <p class="font-semibold text-lg text-white/80 mb-4">
                The global automotive market is worth over $3.6 trillion, yet…
            </p>
            <ul class="font-normal text-white/80 list-disc pl-5 text-lg">
                <li class="pl-3 mb-3 leading-tight">Margins are razor-thin — average dealer net profit is ~2%.</li>
                <li class="pl-3 mb-3 leading-tight">90% of dealership revenue comes from the same sources as 20 years ago.</li>
                <li class="pl-3 leading-tight">Genuine new revenue streams are rare and hard to scale.</li>
            </ul>

        </ImageAndText>

    </Page>

</template>